import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { approveManPowerVm } from '../models/approveManPowerVm';
import { approveMovementVm } from '../models/approveMovementVm';
import { MovementDto } from '../models/MovementDto';
import { MovementPendingApprovalDto } from '../models/MovementPendingApprovalDto';
import { DateRangeRequest } from '../models/requests/DateRangeRequest';
import { ManpowerJDDto } from '../models/requests/ManpowerJDDto';
import { MovementJDDto } from '../models/requests/MovementJDDto';
import { MovementJDVM } from '../models/requests/MovementJDVM';
import { MovementRequestVM } from '../models/requests/MovementRequestVM';
import { ApiResponseObject } from '../models/responses/api-response-object';

@Injectable({
  providedIn: 'root'
})
export class MovementService {

  constructor(private httpClient: HttpClient) { }

  
  saveMovement(newmovementRequest: MovementRequestVM): Observable<ApiResponseObject<MovementDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto>>(`${environment.apiUrl}/MovementRequests`, newmovementRequest);
  }
  getMovement(): Observable<ApiResponseObject<MovementDto[]>> {
    ; 
   var result = this.httpClient.get<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/ViewMyMovementRequests`);
   return result;
 }
  
  getPendingMovement(): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/MyPendingRequests`);
  }

    approveMovement(approveMovementRequest: approveMovementVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/MovementRequests/Approve`, approveMovementRequest);
  }

  
 getPendingRequestApprovals(id:number): Observable<ApiResponseObject<MovementPendingApprovalDto[]>> {
  ;
  return this.httpClient.get<ApiResponseObject<MovementPendingApprovalDto[]>>(`${environment.apiUrl}/MovementRequests/GetMovementPendingApproval/${id}`);
}


getNewMovementRequest(): Observable<ApiResponseObject<MovementDto[]>> {
  ;
  return this.httpClient.get<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/MyPendingRequests`);
}
  
  rejectMovement(approveMovementRequest: approveMovementVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/MovementRequests/Reject`, approveMovementRequest);
  }

  fileExtention(name: any ) {
    ;
    const regex = /(?:\.([^.]+))?$/;
    return regex.exec(name)![1];
  }
  
  
   GetJDForRequest(ContractId:number): Observable<ApiResponseObject<MovementJDDto[]>> {
     ;
     return this.httpClient.get<ApiResponseObject<MovementJDDto[]>>(`${environment.apiUrl}/MovementRequests/GetAdditionalDocument/${ContractId}`);
   }
   GetByempDestinationLocation(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByEmpDestinationLocation`, obj);
    //return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByEmpDestinationLocation/${name}`);
  }
  
  GetByempInitialLocation(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByInitialLocation`, obj);
  }
  
  GetByempDestinationFunction(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByEmpDestinationFunction`, obj);
  }

  GetByempCurrentFunction(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByEmpCurrentfunction`, obj);
  }

  GetByStatus(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByStatus`, obj);
  }
  getByDateRange(dateRangeRequest: DateRangeRequest): Observable<ApiResponseObject<MovementDto[]>> {
   
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/getByDateRange`, dateRangeRequest);
  }

  SendManualReminder(obj: any): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/SendManualReminder`, obj);
  }
    CancelRequest(data: any): Observable<ApiResponseObject<MovementDto>> {

    return this.httpClient.post<ApiResponseObject<MovementDto>>(`${environment.apiUrl}/MovementRequests/CancelRequest`, data);
  }
  
  MyApprovedManpowerRequests(): Observable<ApiResponseObject<MovementDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/MyApprovedMovementRequests`);
  }

}
